import React from "react";
import { FaInstagram, FaFacebookF, FaYoutube, FaTwitter } from "react-icons/fa";

const FooterFrontend = () => {
  return (
    <footer className="bg-[#343C8D] px-4 py-12 text-white md:px-20">
      <div className="flex flex-col justify-between gap-10 pb-8 md:flex-row">
        {/* Left Section */}
        <div className="flex-1">
          <h3 className="mb-2 text-lg font-bold">★★★</h3>
          <h2 className="mb-2 text-2xl font-bold">Makku</h2>
          <p className="mb-4 text-sm leading-relaxed">
            Discover the world with Makku – your reliable partner for both
            luxury and affordable hotel stays. Unlock great deals and book with
            ease and confidence.
          </p>
          <div className="space-y-1 text-sm">
            <p>
              <strong>Address:</strong> 123 Traveling Street, Surat, Gujarat
            </p>
            <p>
              <strong>Email:</strong> support@Makku.com
            </p>
            <p>
              <strong>Phone:</strong> +91 (800) 123-4567
            </p>
          </div>
          <div className="mt-4 flex gap-3">
            <a href="#" aria-label="Twitter">
              <FaTwitter className="hover:text-yellow-300" />
            </a>
            <a href="#" aria-label="Instagram">
              <FaInstagram className="hover:text-yellow-300" />
            </a>
            <a href="#" aria-label="Facebook">
              <FaFacebookF className="hover:text-yellow-300" />
            </a>
            <a href="#" aria-label="YouTube">
              <FaYoutube className="hover:text-yellow-300" />
            </a>
          </div>
        </div>

        {/* Center Section */}
        <div className="flex-1">
          <h3 className="mb-3 text-lg font-bold">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            {[
              "Home",
              "Destinations",
              "Why Makku?",
              "Top Hotels",
              "About Us",
              "Contact",
              "FAQs",
            ].map((link) => (
              <li
                key={link}
                className="cursor-pointer transition-all hover:underline"
              >
                {link}
              </li>
            ))}
          </ul>
        </div>

        {/* Right Section */}
        <div className="flex-1">
          <div className="h-full rounded-2xl border border-white bg-[#2e347a] p-5">
            <h3 className="mb-3 text-lg font-bold">
              Enjoy Members-Only Offers and Expert Guidance!
            </h3>
            <p className="mb-4 text-sm">
              Stay ahead with exclusive deals, expert travel tips, and curated
              suggestions for your next journey. Subscribe now!
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <input
                type="email"
                placeholder="Your-email@mail.com"
                className="bg-transparent min-w-[200px] flex-1 border-b border-white px-2 py-1 text-black outline-none placeholder:text-gray-300"
              />
              <button className="rounded-full border border-white px-6 py-1 text-sm text-white transition-all hover:bg-white hover:text-[#343C8D]">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterFrontend;
